import type { Projectbetrokkene } from '@models/Projectbetrokkene'

import { apiClient } from '../../gateways/api'

export { createProjectbetrokkene }

const createProjectbetrokkene = async ({
  projectbetrokkene,
}: {
  projectbetrokkene: Projectbetrokkene
}): Promise<Projectbetrokkene> => {
  const { data } = await apiClient({
    url: `/rest/projectbetrokkene`,
    method: 'POST',
    data: projectbetrokkene,
  })

  return data
}
